import storeE from "../../../store";

export const validateStep4 = () => {
    return isOwnerValid() && isApproverValid() === true && isGdprValid() && isSensitiveGdprValid() && isConfirmGdprValid();
}

export const isGdprValid = () => {
    const siteInfo = storeE.getState().newSite;
    return siteInfo.Gdpr !== null;
}

export const isSensitiveGdprValid = () => {
    const siteInfo = storeE.getState().newSite;
    if(siteInfo.Gdpr === false) return true;
    return siteInfo.SensitiveGdpr !== null;
}

export const isOwnerValid = () => {
    const siteInfo = storeE.getState().newSite;
    return siteInfo.isIATU || siteInfo.isIAPCP || !!siteInfo.Owner;
}

export const isApproverValid = () => {
    const siteInfo = storeE.getState().newSite;
    const onPremise = siteInfo.OnPremiseState;
    const approver = siteInfo.Approver;
    if(onPremise && !approver) {  
        return 'Please contact Support to fill in your Line Manager in organization structure.';
    }
    return siteInfo.isIATUtrue || true;
}

export const isConfirmGdprValid = () => {
    const siteInfo = storeE.getState().newSite;
    return siteInfo.ConfirmGdpr;
}



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step4/Validator.js